import React, { Component } from 'react'
import Link from '../utils/link'
import SocialIcons from './social-icons'
import SubscribeForm from './subscribe-form'
import { KolloscheK } from './icons'
import NewsletterImage from '../assets/images/newsletter-man-in-suit.png'

class Subscribe extends Component {

  render() {

    return (
      <section className='subscribe'>
        <div className='subscribe__inner'>
            <div className='subscribe__content'>

                <div className='subscribe__details'>
                     <div className='icon'>
                        <KolloscheK color='#FFFFFF' />
                        <p>Utmost integrity. Premium results.</p>
                    </div>
                    <div className='subscribe__image'>
                        <img className='' src={NewsletterImage} alt='' />
                    </div>
                </div>

                <div className='subscribe__social-form'>

                    <div className='subscribe__social'>

                        <p>Our newsletter gives you exclusive access to latest listings, sales and trusted insights from the industry’s best agents.</p>

                        <SocialIcons color='#FFFFFF' />

                    </div>

                    <div className='subscribe__form'>
                        <SubscribeForm />
                    </div>

                </div>

            </div>
        </div>
      </section>
    )
  }
}

export default Subscribe
